import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Popup, Form, Button, Pager, Paging, GroupPanel, SearchPanel, Grouping, RemoteOperations, MasterDetail } from "devextreme-react/data-grid";
import ItemProperties from "../../components/itemProperties/ItemProperties";
import { useDispatch } from 'react-redux';
import { Label } from "devextreme-react/form";
import { CommonSeriesSettingsHoverStyle } from "devextreme-react/chart";
import Title from "../../components/shared/Title";
import BlockHeader from "../../components/shared/BlockHeader";
import { openThisDialog } from '../../store/dialog/dialogReducer';
import { openEditDialog } from "../../store/editDialog/editDialogReducer";
import AddCatalogEntryDialog from "./AddCatalogEntryDialog";
import EditCatalogEntryDialog from "./EditCatalogEntryDialog";
import DetailTemplate from "./DetailTemplate";


const CatalogGroup = props => {

const {catalogSource }=props;

let dispatch = useDispatch();
const gridRef = useRef();

const onToolbarPreparing = e => {

    e.toolbarOptions.items.unshift({
        location: 'before',
        widget: 'dxButton',
        options: {
            text: 'Exportar a excel',
            icon: 'xlsxfile',
            type: 'success',
            stylingMode: "outlined",
            onClick: () => gridRef.current.instance.exportToExcel(false)
        }
    });
}



    return (
        <DataGrid
            dataSource={catalogSource}
            showBorders={true}
            selection={{ mode: 'single' }}
            showRowLines={true}
            hoverStateEnabled={true}
            onToolbarPreparing={onToolbarPreparing}
            rowAlternationEnabled={true}
            ref={gridRef}
            keyExpr="catalog"

        >
            <Editing
                // mode="popup"
                allowUpdating={true}
                allowDeleting={false}
                allowAdding={false}
                useIcons={true}
            >

            </Editing>


            <Pager allowedPageSizes={[15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
            <Paging defaultPageSize={15} />
            <Column dataField="catalog" caption="Catalogo" allowEditing={false} visible={false}/>
           <Column dataField="description" caption="Descripción-Catalogo" allowEditing={false}  /> 
            <MasterDetail
                enabled={true}
                component={DetailTemplate}
                test={45}
            />
            <Column type="buttons">
                <Button name="edit" onClick={(e) => { dispatch(openThisDialog(e.row.data.catalog)); }} />
            </Column>
        </DataGrid>
    );
}

export default CatalogGroup;